export default __webpack_public_path__ + "static/unleash-joy-yellow-f6aa68533d274baa58f486b7ce86fbf0.svg";